// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { FormattedText } = require('core/i18n').i18n;
const { getFirstNChars, toCamelCase, getLastNChars } = require('utilities/stringHelper');
const classNames = require('classnames');
const lodash = require('lodash');

// @commons
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const { Accordion } = require('commonsComponents/accordion');
const { AccordionHeader } = require('commonsComponents/accordionHeader');
const { AccordionBody } = require('commonsComponents/accordionBody');

const {
    CARD_ECARD,
    CARD_CREDIT,
    CARD_DEBIT,
    MY_PROFILE_ACCOUNT,
    WALLETS,
    FUNDS,
    PLANS,
    MORTGAGES,
    LOANS,
    SAVINGS
} = require('constants/index');

// @helpers
const { formatAmount, formatCurrency } = require('utilities/currencyHelper');
const { getFamily } = require('utilities/rightsProfileHelper');
const trim = require('lodash/string/trim');


class PortableProductDetailAccordion extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            productDetailList: props.saveList,
            checkAll: false,
            checkAllProducts: false,
            allChecksHeadersStatus: this.props.allChecksHeadersStatus
        }

        this.handleProductDetailCheck = this.handleProductDetailCheck.bind(this);
        this.getAllAccountList = this.getAllAccountList.bind(this);
        this.handleHeaderCheck = this.handleHeaderCheck.bind(this);
        this.getAllCreditCardList = this.getAllCreditCardList.bind(this);
        this.getAllList = this.getAllList.bind(this);
        this.getAllLoansMortgagesList = this.getAllLoansMortgagesList.bind(this);
        this.updateAllHeaders = this.updateAllHeaders.bind(this);
        this.addProduct = this.addProduct.bind(this);
        this.deleteProduct = this.deleteProduct.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            checkAllProducts: nextProps.doActionChangeALl,
            allChecksHeadersStatus: nextProps.allChecksHeadersStatus
        });
    }

    // update all headers with values (true or false)
    updateAllHeaders() {
        const { doActionChangeALl, type } = this.props;
        const { allChecksHeadersStatus } = this.state;

        if (doActionChangeALl) {
            switch (type) {
                case WALLETS:
                case FUNDS:
                case PLANS:
                    this.getAllList(allChecksHeadersStatus);
                    break;
                case CARD_ECARD:
                case CARD_DEBIT:
                case CARD_CREDIT:
                    this.getAllCreditCardList(allChecksHeadersStatus);
                    break;
                case MY_PROFILE_ACCOUNT:
                    this.getAllAccountList(allChecksHeadersStatus);
                break;
                case LOANS:
                case MORTGAGES:
                    this.getAllLoansMortgagesList(allChecksHeadersStatus);
                break;
            }
        }
    }

    // return amount with currency
    getAmountString(amount, currency) {
        return(`${formatAmount(amount)} ${formatCurrency(currency)}`);
    }

    getFilterSimilar(firstProduct, secondProduct) {
        return(firstProduct.split(' ').join('').toUpperCase() === secondProduct.split(' ').join('').toUpperCase());
    }

    // get header, total amount and icons for product header´s accordion
    getHeaderAccordionDetails() {
        const { type, product, selectFilter, immWalletSummarization } = this.props;
        const { productDetailList } = this.state;
        let dataToRender = {};
        let isFilteredSelectedProducts;
        let injectedStrings;
        let isFiltered;

        dataToRender.iconClass = classNames('portable-products-accordion__icon-accordion icon', {
            'rebrand-accounts': type === MY_PROFILE_ACCOUNT,
            'rebrand-credit-card': type === CARD_DEBIT || type === CARD_CREDIT,
            'rebrand-ecard': type === CARD_ECARD,
            'rebrand-wallets': type === WALLETS,
            'rebrand-funds': type === FUNDS,
            'rebrand-plans': type === PLANS,
            'rebrand-mortgages': type == MORTGAGES,
            'rebrand-loans': type == LOANS,
            'rebrand-savings': type == SAVINGS
        });

        switch (type) {
            case FUNDS:
            case PLANS:
                isFiltered = product.filter((productDetail) => this.getFilterSimilar(productDetail.getIn(['descIntervenciones', 'nomTipInterv']), selectFilter));
                isFilteredSelectedProducts = productDetailList.filter((p) => this.getFilterSimilar(p[1].interveners, selectFilter));
                injectedStrings = [
                    selectFilter === '' ? productDetailList.length : isFilteredSelectedProducts.length,
                    selectFilter === '' ? product.size : isFiltered.size
                ];

                dataToRender.totalAmountHeader = this.getAmountString(immWalletSummarization.getIn([`${type === FUNDS ? 'funds' : 'plans'}`, 'balance']).toJS()[0].amount, immWalletSummarization.getIn([`${type === FUNDS ? 'funds' : 'plans'}`, 'balance']).toJS()[0].currency);
                dataToRender.header = <FormattedText value={`${type === FUNDS ? 'rightsPortable-fundsTitleAccordion' : 'rightsPortable-plansTitleAccordion'}`} injectedStrings={injectedStrings} />;
                dataToRender.showProduct = selectFilter === '' ? true : isFiltered.size > 0;
                break;
            case MORTGAGES:
            case LOANS:
                isFilteredSelectedProducts = productDetailList.filter((p) => this.getFilterSimilar(p[1].interveners, selectFilter));
                isFiltered = product.filter((productDetail) => this.getFilterSimilar(productDetail.get('interventionType'), selectFilter));
                injectedStrings = [
                    selectFilter === '' ? productDetailList.length : isFilteredSelectedProducts.length,
                    selectFilter === '' ? product.size : isFiltered.size
                ];

                dataToRender.totalAmountHeader = 0;
                dataToRender.header = <FormattedText value={`${type === LOANS ? 'rightsPortable-loansTitleAccordion' : 'rightsPortable-mortgagesTitleAccordion'}`} injectedStrings={injectedStrings}/>;
                dataToRender.showProduct = selectFilter === '' ? true : isFiltered.size > 0;
                break;
            case WALLETS:
                isFiltered = product.filter((wallet) => this.getFilterSimilar(wallet.get('intervenerType'), selectFilter));
                isFilteredSelectedProducts = productDetailList.filter((p) => this.getFilterSimilar(p[1].interveners, selectFilter));
                injectedStrings = [
                    selectFilter === '' ? productDetailList.length : isFilteredSelectedProducts.length,
                    selectFilter === '' ? product.size : isFiltered.size
                ];

                dataToRender.totalAmountHeader = this.getAmountString(immWalletSummarization.getIn(['values', 'balance']).toJS()[0].amount, immWalletSummarization.getIn(['values', 'balance']).toJS()[0].currency);
                dataToRender.header = <FormattedText value="rightsPortable-walletTitleAccordion" injectedStrings={injectedStrings} />
                dataToRender.showProduct = selectFilter === '' ? true : isFiltered.size > 0;
                break;
            case CARD_ECARD:
            case CARD_DEBIT:
            case CARD_CREDIT:
                isFilteredSelectedProducts = productDetailList.filter((p) => this.getFilterSimilar(p[1].interveners, selectFilter));
                injectedStrings = [
                    selectFilter === '' ? productDetailList.length : isFilteredSelectedProducts.length,
                    this.getTotalCardsByType(type, true, selectFilter)
                ];
                const titleMap = {
                    [CARD_ECARD]: 'rightsPortable-cardsETypeTitleAccordion',
                    [CARD_CREDIT]: 'rightsPortable-cardsTitleAccordion',
                    [CARD_DEBIT]: 'rightsPortable-cardsDebitTypeTitleAccordion'
                }


                dataToRender.totalAmountHeader = this.getAmountString(product.getIn([type, 'availableBalanceForPG']).toJS()[0].amount, product.getIn([type, 'availableBalanceForPG']).toJS()[0].currency)
                dataToRender.header = <FormattedText value={titleMap[type]} injectedStrings={injectedStrings} />;
                dataToRender.showProduct = selectFilter === '' ? true : this.getTotalCardsByType(type, true, selectFilter) > 0;
                break;
            case MY_PROFILE_ACCOUNT:
                const immAccountByOrders = product.get('byOrder');
                const immAccountsById = product.get('byId');
                isFiltered = immAccountByOrders.filter((product) => this.getFilterSimilar(immAccountsById.get(product).get('interventionType'), selectFilter));
                isFilteredSelectedProducts = productDetailList.filter((p) => this.getFilterSimilar(p[1].interveners, selectFilter));
                injectedStrings = [
                    selectFilter === '' ? productDetailList.length : isFilteredSelectedProducts.length,
                    selectFilter === '' ? product.get('byOrder').size : isFiltered.size
                ];

                dataToRender.totalAmountHeader = this.getAmountString(formatAmount(product.get('balanceForGlobalPosition').toJS()[0].amount), formatCurrency(product.get('balanceForGlobalPosition').toJS()[0].currency));
                dataToRender.header = <FormattedText value="rightsPortable-accountsTitleAccordion" injectedStrings={injectedStrings}/>;
                dataToRender.showProduct = selectFilter === '' ? true : isFiltered.size > 0;
                break;
        }

        return dataToRender;
    }

    handleHeaderCheck() {
        const { type, product, selectFilter } = this.props;
        const { checkAll, productDetailList } = this.state;
        let changeCheck;

        switch (type) {
            case LOANS:
            case MORTGAGES:
                changeCheck = productDetailList.length >= 0 && productDetailList.length < product.size;
                if (productDetailList.length === product.size) {
                    this.getAllLoansMortgagesList(false);
                } else {
                    this.getAllLoansMortgagesList(changeCheck ? true : !checkAll);
                }
                this.setState({
                    checkAll: changeCheck ? true : !checkAll
                });
                break;
            case WALLETS:
            case FUNDS:
            case PLANS:
                changeCheck = productDetailList.length >= 0 && productDetailList.length < product.size;
                if (productDetailList.length === product.size) {
                    this.getAllList(false);
                } else {
                    this.getAllList(changeCheck ? true : !checkAll);
                }
                this.setState({
                    checkAll: changeCheck ? true : !checkAll
                });
                break;
            case CARD_ECARD:
            case CARD_DEBIT:
            case CARD_CREDIT:
                changeCheck = productDetailList.length >= 0 && productDetailList.length < this.getTotalCardsByType(type, true, selectFilter);
                if (productDetailList.length === this.getTotalCardsByType(type, true, selectFilter)) {
                    this.getAllCreditCardList(false);
                } else {
                    this.getAllCreditCardList(changeCheck ? true : !checkAll);
                }
                this.setState({
                    checkAll: changeCheck ? true : !checkAll
                });
                break;
            case MY_PROFILE_ACCOUNT:
                changeCheck = productDetailList.length >= 0 && productDetailList.length < product.get('byOrder').size;
                changeCheck = productDetailList.length === product.get('byOrder').size && this.state.checkAll ? false : changeCheck;
                if (productDetailList.length === product.get('byOrder').size) {
                    this.getAllAccountList(false);
                } else {
                    this.getAllAccountList(changeCheck ? true : !checkAll);
                }
                this.setState({
                    checkAll: changeCheck ? true : !checkAll
                });
            break;
        }
    }

    // add product to reducer
    addProduct(productNewlist) {
        const { changeListFunc, type } = this.props;
        const { productDetailList } = this.state;
        const modifyQuantity = productNewlist.length - productDetailList.length;

        this.setState({
            productDetailList: productNewlist
        });
        changeListFunc(type, productNewlist, modifyQuantity);
    }

    // delete product to reducer
    deleteProduct(productNewlist) {
        const { changeListFunc, type } = this.props;
        const { productDetailList } = this.state;

        const modifyQuantity = -productDetailList.length;

        this.setState({
            productDetailList: productNewlist
        });
        changeListFunc(type, productNewlist, modifyQuantity);
    }

    // get all mortgages and loans
    getAllLoansMortgagesList(allChecked) {
        const { product, showMovements, type } = this.props;
        let productNewlist = [];
        if (allChecked) {
            product.map((product) => {
                productNewlist.push(
                    [
                        {
                            numContract: `${product.get('product')}${product.get('contractNumber')}`,
                            movements: showMovements,
                            family: getFamily(type),
                            consentStatus: "00"
                        },
                        {
                            title: this.getAlias(product),
                            subTitle: this.getSecondAlias(product),
                            amount: type == LOANS || type == MORTGAGES ? this.getSecondAmount(product) : this.getFirstAmount(product),
                            interveners: this.getIntervener(product)
                        }
                    ]
                );
            });
            this.addProduct(productNewlist);
        } else {
            this.deleteProduct(productNewlist);
        }
    }

    // get all plans, futures and wallets and loans
    getAllList(allChecked) {
        const { product, showMovements, type } = this.props;
        let productNewlist = [];
        if (allChecked) {
            product.map((product) => {
                productNewlist.push(
                    [
                        {
                            numContract: `${product.getIn(['contrato', 'producto'])}${product.getIn(['contrato', 'numerodecontrato'])}`,
                            movements: showMovements,
                            family: getFamily(type),
                            consentStatus: "00"
                        },
                        {
                            title: this.getAlias(product),
                            subTitle: this.getSecondAlias(product),
                            amount: type == LOANS || type == MORTGAGES ? this.getSecondAmount(product) : this.getFirstAmount(product),
                            interveners: this.getIntervener(product)
                        }
                    ]
                );
            });
            this.addProduct(productNewlist);
        } else {
            this.deleteProduct(productNewlist);
        }
    }

    // get all kinds of cards
    getAllCreditCardList(allChecked) {
        const { product, type, showMovements } = this.props;
        const immCardsList = product.get('byOrder');
        const immCardsById = product.get('byId');
        let productNewlist = [];

        if (allChecked) {
            immCardsList.map((card) => {
                const immCard = immCardsById.get(card);
                if (immCard.get('type') === type) {
                    productNewlist.push(
                        [
                            {
                                numContract: `${immCard.getIn(['contract', 'product'])}${immCard.getIn(['contract', 'number'])}`,
                                movements: showMovements,
                                family: getFamily(type),
                                consentStatus: "00"
                            },
                            {
                                title: this.getAlias(card),
                                subTitle: this.getSecondAlias(card),
                                amount: this.getFirstAmount(card),
                                interveners: this.getIntervener(card)
                            }
                        ]
                    );
                }
            });
            this.addProduct(productNewlist);
        } else {
            this.deleteProduct(productNewlist);
        }

    }

    // get all kind of accounts
    getAllAccountList(allChecked) {
        const { product,  showMovements, type } = this.props;
        const productAccordion = product.get('byOrder')
        const immAccountsById = product.get('byId');
        let productNewlist = [];
        if (allChecked) {
            productAccordion.map((account) => {
                const immAccount = immAccountsById.get(account);
                productNewlist.push(
                    [
                        {
                            numContract: `${immAccount.get('product')}${immAccount.get('contractNumber')}`,
                            movements: showMovements,
                            family: getFamily(type),
                            consentStatus: "00"
                        },
                        {
                            title: this.getAlias(account),
                            subTitle: this.getSecondAlias(account),
                            amount: this.getFirstAmount(account),
                            interveners: this.getIntervener(account)
                        }
                    ]
                )
            });
            this.addProduct(productNewlist);
        } else {
            this.deleteProduct(productNewlist);
        }
    }

    // check product separatly
    handleProductDetailCheck(obj, id, checked) {
        const { changeListFunc, type } = this.props;
        const { productDetailList } = this.state;
        let productList = productDetailList;
        let modifyQuantity;
        if (checked) {
            productList.push(obj);
            modifyQuantity = 1;
        } else {
            const index = lodash.findIndex(productList, function(o) { return o[0].numContract == id; })
            if (index > -1) {
              productList.splice(index, 1);
            }
            modifyQuantity = -1;
        }

        this.setState({
            productDetailList: productList,
        });
        changeListFunc(type, productList, modifyQuantity);
    }

    getTotalCardsByType(type, size, filter) {
        const { product, selectFilter } = this.props;
        const immCardsList = product.get('byOrder');
        const immCardsById = product.get('byId');

        const filteredImmCardsList = immCardsList.filter(cardId => {
            const immCard = immCardsById.get(cardId);
            if (immCard.get('type') === type) {
                if (filter === '') {
                    return immCard.get('type') === type;
                } else {
                    if (this.getFilterSimilar(immCard.get('interventionType'), selectFilter)) {
                        return immCard.get('type') === type;
                    }
                }
            }
        });

        return size ? filteredImmCardsList.size : filteredImmCardsList;
    }

    // get interveners for products
    getIntervener(productDetail) {
        const { type, product } = this.props;
        let intervener;

        switch (type) {
            case FUNDS:
            case PLANS:
                intervener = productDetail.getIn(['descIntervenciones', 'nomTipInterv'])
                break;
            case MORTGAGES:
                intervener = productDetail.get('interventionType');
                break;
            case LOANS:
                intervener = productDetail.get('interventionType');
                break;
            case WALLETS:
                intervener = productDetail.get('intervenerType');
                break;
            case CARD_ECARD:
            case CARD_DEBIT:
            case CARD_CREDIT:
                const immCardsById = product.get('byId');
                const immCard = immCardsById.get(productDetail);
                intervener = immCard.get('interventionType');
                break;
            case MY_PROFILE_ACCOUNT:
                const immAccountsById = product.get('byId');
                const immAccount = immAccountsById.get(productDetail);
                intervener = immAccount.get('interventionType')
                break;
        }
        return intervener;
    }

    // know if product have the same filter or not
    getProductFilter(productDetail) {
        const { type, product, selectFilter } = this.props;
        let isFilter = false;

        if(selectFilter !== '') {
            switch (type) {
                case WALLETS:
                    isFilter = this.getFilterSimilar(productDetail.get('intervenerType'), selectFilter);
                    break;
                case FUNDS:
                case PLANS:
                    isFilter = this.getFilterSimilar(productDetail.getIn(['descIntervenciones', 'nomTipInterv']), selectFilter);
                    break;
                case MORTGAGES:
                case LOANS:
                    isFilter = this.getFilterSimilar(productDetail.get('interventionType'), selectFilter);
                    break;
                case CARD_ECARD:
                case CARD_DEBIT:
                case CARD_CREDIT:
                    const immCardsById = product.get('byId');
                    const immCard = immCardsById.get(productDetail);
                    isFilter = this.getFilterSimilar(immCard.get('interventionType'), selectFilter);
                    break;
                case MY_PROFILE_ACCOUNT:
                    const immAccountsById = product.get('byId');
                    const immAccount = immAccountsById.get(productDetail);
                    isFilter = this.getFilterSimilar(immAccount.get('interventionType'), selectFilter);
                    break;
            }
        } else {
            isFilter = true;
        }

        return isFilter;
    }

    // get alias for product
    getAlias(productDetail) {
        const { type, product } = this.props;
        let alias;

        switch (type) {
            case FUNDS:
            case PLANS:
                alias = trim(productDetail.get('descripcion'));
                break;
            case MORTGAGES:
            case LOANS:
                alias = productDetail.get('alias');
                break;
            case WALLETS:
                alias = trim(productDetail.get('name'));
                break;
            case CARD_ECARD:
            case CARD_DEBIT:
            case CARD_CREDIT:
                const immCardsById = product.get('byId');
                const immCard = immCardsById.get(productDetail);
                alias = immCard.get('alias').get('current');
                break;
            case MY_PROFILE_ACCOUNT:
                const immAccountsById = product.get('byId');
                const immAccount = immAccountsById.get(productDetail);

                alias = immAccount.get('isAliasUpdating')
                    ? toCamelCase(immAccount.get('aliasTentative'))
                    : toCamelCase(immAccount.get('alias'));
                break;
        }
        return alias;
    }

    // get second alias for products
    getSecondAlias(productDetail) {
        const { type, product } = this.props;
        let subTitle;

        switch (type) {
            case LOANS:
            case MORTGAGES:
                subTitle = getLastNChars(productDetail.get('account'));
                break;
            case PLANS:
                subTitle = '';
                break;
            case MY_PROFILE_ACCOUNT:
                const immAccountsById = product.get('byId');
                const immAccount = immAccountsById.get(productDetail);

                subTitle = getLastNChars(immAccount.get('iban'));
                break;
            case CARD_ECARD:
            case CARD_DEBIT:
            case CARD_CREDIT:
                const immCardById = product.get('byId');
                const immCard = immCardById.get(productDetail);

                subTitle = getLastNChars(immCard.get('number'));
        }
        return subTitle;
    }

    // get num contract for products
    getNumContract(productDetail) {
        const { type, product } = this.props;
        let numContract;

        switch (type) {
            case LOANS:
            case MORTGAGES:
                numContract = `${productDetail.get('product')}${productDetail.get('contractNumber')}`;
                break;
            case WALLETS:
            case FUNDS:
            case PLANS:
                numContract = `${productDetail.getIn(['contrato', 'producto'])}${productDetail.getIn(['contrato', 'numerodecontrato'])}`;
                break;
            case CARD_ECARD:
            case CARD_DEBIT:
            case CARD_CREDIT:
                const immCardsById = product.get('byId');
                const immCard = immCardsById.get(productDetail);
                numContract = `${immCard.getIn(['contract', 'product'])}${immCard.getIn(['contract', 'number'])}`;
                break;
            case MY_PROFILE_ACCOUNT:
                const immAccountsById = product.get('byId');
                const immAccount = immAccountsById.get(productDetail);

                numContract = `${immAccount.get('product')}${immAccount.get('contractNumber')}`;
                break;
        }
        return numContract;
    }

    // get first amount for products
    getFirstAmount(productDetail) {
        const { type, product } = this.props;
        let firstAmount;

        switch (type) {
            case LOANS:
            case MORTGAGES:
                firstAmount = '-';
                break;
            case WALLETS:
                firstAmount = this.getAmountString(productDetail.get('totalAmount'), productDetail.get('currency'));
                break;
            case CARD_CREDIT:
            case CARD_DEBIT:
            case CARD_ECARD:
                const immCardsById = product.get('byId');
                const immCard = immCardsById.get(productDetail);
                firstAmount = this.getAmountString(immCard.get('availableBalance').get('amount'), immCard.get('availableBalance').get('currency'));
                break;
            case PLANS:
            case FUNDS:
                firstAmount = this.getAmountString(productDetail.getIn(['saldo1', 'importe']), productDetail.getIn(['saldo1', 'divisa']));
                break;
            case MY_PROFILE_ACCOUNT:
                const immAccountsById = product.get('byId');
                const immAccount = immAccountsById.get(productDetail);
                firstAmount = this.getAmountString(immAccount.getIn(['balances', 'realBalance', 'amount']), immAccount.getIn(['balances', 'realBalance', 'currency']));
                break;
        }
        return firstAmount;
    }

    // get second amount for products
    getSecondAmount(productDetail) {
        const { type, product } = this.props;

        let secondAmount;

        switch (type) {
            case LOANS:
            case MORTGAGES:
                secondAmount = this.getAmountString(productDetail.get('balance').get('amount'), productDetail.get('balance').get('currency'));
                break;
            case WALLETS:
                secondAmount = this.getAmountString(productDetail.getIn(['saldo1', 'importe']), productDetail.getIn(['saldo1', 'divisa']));
                break;
            case FUNDS:
                secondAmount =  this.getAmountString(productDetail.get('saldo2').get('valorliquidativo'), productDetail.get('saldo2').get('divisa'));
                break;
            case CARD_ECARD:
                const immECardsById = product.get('byId');
                const immECard = immECardsById.get(productDetail);
                secondAmount = this.getAmountString(immECard.get('availableBalance').get('amount'), immECard.get('availableBalance').get('currency'));
                break;
            case CARD_DEBIT:
                const immDebitCardsById = product.get('byId');
                const immDebitCard = immDebitCardsById.get(productDetail);
                secondAmount = this.getAmountString(immDebitCard.get('limit').get('amount'), immDebitCard.get('limit').get('currency'));
                break;
            case CARD_CREDIT:
                const immCardsById = product.get('byId');
                const immCard = immCardsById.get(productDetail);
                secondAmount = this.getAmountString(immCard.get('limit').get('amount'), immCard.get('limit').get('currency'));
                break;
            case PLANS:
                secondAmount = this.getAmountString(productDetail.getIn(['saldo2', 'importe']), productDetail.getIn(['saldo2', 'divisa']));
                break;
            case MY_PROFILE_ACCOUNT:
                const immAccountsById = product.get('byId');
                const immAccount = immAccountsById.get(productDetail);
                secondAmount = this.getAmountString(immAccount.getIn(['balances', 'availableBalance', 'amount']), immAccount.getIn(['balances', 'availableBalance', 'currency']));
                break;
        }
        return secondAmount;
    }

    // get title
    getFirstTitleAmount() {
        const { type } = this.props;

        let firstTitle;

        switch (type) {
            case WALLETS:
            case LOANS:
            case MORTGAGES:
            case FUNDS:
            case CARD_ECARD:
            case CARD_DEBIT:
            case CARD_CREDIT:
            case PLANS:
            case MY_PROFILE_ACCOUNT:
                firstTitle = <FormattedText value="rightsPortable-availableBalanceAccount"/>;
                break;
        }
        return firstTitle;
    }

    // get title
    getSecondTitleAmount() {
        const { type } = this.props;

        let secondTitle;

        switch (type) {
            case LOANS:
            case MORTGAGES:
            case WALLETS:
            case FUNDS:
            case CARD_ECARD:
            case CARD_DEBIT:
            case CARD_CREDIT:
            case PLANS:
            case MY_PROFILE_ACCOUNT:
                secondTitle = <FormattedText value="rightsPortable-realBalanceAccount"/>;
                break;
        }
        return secondTitle;
    }

    // get all information for products
    getProductDetails() {
        const { product, type, showMovements, selectFilter } = this.props;
        const{ productDetailList } = this.state;
        let productAccordion = product;

        if (type === MY_PROFILE_ACCOUNT) {
            productAccordion = product.get('byOrder')
        } else if(type ===  CARD_CREDIT) {
            productAccordion = this.getTotalCardsByType(CARD_CREDIT, false, selectFilter.toUpperCase());
        } else if(type ===  CARD_DEBIT) {
            productAccordion = this.getTotalCardsByType(CARD_DEBIT, false, selectFilter.toUpperCase());
        }else if(type === CARD_ECARD) {
            productAccordion = this.getTotalCardsByType(CARD_ECARD, false, selectFilter.toUpperCase());
        }

        return productAccordion.map((productDetail, index) => {
            const title = this.getAlias(productDetail);
            const hasFilter = this.getProductFilter(productDetail);
            const subTitle = this.getSecondAlias(productDetail);
            const interveners = this.getIntervener(productDetail)
            const numContract = this.getNumContract(productDetail);
            const salaryOne = type == LOANS || type == MORTGAGES ? this.getSecondAmount(productDetail) : this.getFirstAmount(productDetail)
            // const salaryTwo = this.getSecondAmount(productDetail);
            const firstTitleAmount = type == LOANS || type == MORTGAGES ? this.getSecondTitleAmount() : this.getFirstTitleAmount()
            // const secondTitleAmount = this.getSecondTitleAmount();
            const valueCheckBox = lodash.findIndex(productDetailList, function(o) { return o[0].numContract == numContract; }) > -1;
            const objProduct = [
                {
                    numContract: numContract,
                    movements: showMovements,
                    family: getFamily(type),
                    consentStatus: "00"
                },
                {
                    title: title,
                    subTitle: subTitle,
                    amount: salaryOne,
                    interveners: interveners
                }
            ];

            // SECOND TITLE
            // <div className="portable-products-accordion__profile-check-info-detail-containers">
            //     <div className="portable-products-accordion__accordion-title-header-text">
            //         {secondTitleAmount}
            //     </div>
            //     <div className="portable-products-accordion__accordion-title-sub-header-text">{salaryTwo}</div>
            // </div>

            if (hasFilter) {
                return (
                    <div key={index} className="portable-products-accordion__content-body">
                        <OKCheckbox
                            extraClass="portable-products-accordion__profile-check-button"
                            idName={numContract}
                            value={valueCheckBox}
                            onChange={evt => this.handleProductDetailCheck(objProduct, evt.target.id, evt.target.checked)}
                            label={<div className="portable-products-accordion__profile-check">
                                <div className="portable-products-accordion__profile-check-alias-detail">
                                    <b className="portable-products-accordion__profile-check-alias-detail-sub-left">{getFirstNChars(title, 30)}</b>
                                    <span className="portable-products-accordion__profile-check-alias-detail-sub-right">{subTitle}</span>
                                </div>
                                <div className="portable-products-accordion__profile-check-info-detail">
                                    <div className="portable-products-accordion__profile-check-info-detail-containers">
                                        <div className="portable-products-accordion__accordion-title-header-text">
                                            {firstTitleAmount}
                                        </div>
                                        <div className="portable-products-accordion__accordion-title-sub-header-text">{salaryOne}</div>
                                    </div>
                                </div>
                            </div>}
                        />
                    </div>
                );
            }
        });
    }

    getIsAllCheck() {
        const { productDetailList } = this.state;
        const { type, product, selectFilter } = this.props
        let isAllCheck;

        switch (type) {
            case WALLETS:
            case FUNDS:
            case PLANS:
            case MORTGAGES:
            case LOANS:
                isAllCheck = productDetailList.length === product.size;
                break;
            case CARD_ECARD:
            case CARD_CREDIT:
            case CARD_DEBIT:
                isAllCheck = productDetailList.length === this.getTotalCardsByType(type, true, selectFilter.toUpperCase());
                break;
            case MY_PROFILE_ACCOUNT:
                isAllCheck = productDetailList.length === product.get('byOrder').size;
                break;
        }
        return isAllCheck;
    }

    render() {
        const { idType } = this.props;
        const dataToRender = this.getHeaderAccordionDetails();
        const checkAll = this.getIsAllCheck();

        this.updateAllHeaders();

        if (dataToRender.showProduct) {
            return(
                <Accordion customClassName="portable-products-accordion__accordion">
                    <AccordionHeader name="AccordionHeader" iconStyle="secondary">
                        <div className="portable-products-accordion__accordion-header">
                            <OKCheckbox
                                extraClass="portable-products-accordion__check-header-accordion"
                                idName={idType}
                                onChange={this.handleHeaderCheck}
                                value={checkAll}
                                label={
                                    <div>
                                        <i className={dataToRender.iconClass} />
                                        <h4 className="portable-products-accordion__accordion-title">
                                            {dataToRender.header}
                                        </h4>
                                    </div>
                                }
                            />
                        </div>
                    </AccordionHeader>
                    <AccordionBody name="AccordionBody">
                        <div className="portable-products-accordion__accordion-body">
                            {this.getProductDetails()}
                        </div>
                    </AccordionBody>
                </Accordion>
            )
        } else {
            return null;
        }
    }
}


PortableProductDetailAccordion.propTypes = {
    product: PropTypes.obj,
    type: PropTypes.string,
    allChecked: PropTypes.bool,
    changeListFunc: PropTypes.func,
    listParent: PropTypes.obj,
    saveChecksValues: PropTypes.bool,
    dataToRender: PropTypes.obj,
    idType: PropTypes.string,
    saveList: PropTypes.array,
    allChecksHeadersStatus: PropTypes.bool,
    doActionChangeALl: PropTypes.bool,
    showMovements: PropTypes.bool,
    selectFilter: PropTypes.string,
    immWalletSummarization: PropTypes.obj
};

module.exports = PortableProductDetailAccordion;
